<template>
    <div class="add-task-dialog" :key="menuKey">
        <div class="add-task-title">
            <h3>任务批量配置</h3>
        </div>
        <!-- <el-divider></el-divider> -->
        <el-form ref="form" label-width="150px" class="add-task-form" size="small" id="myform">
            <el-divider v-if="strategyParam.taskBaseParams"><strong>任务基本参数</strong></el-divider>
            <el-form-item label="策略">
                <el-select v-model="strategySelectData" @change="strategyChange" placeholder="请先选择策略">
                    <el-option v-for="(strategy, index) in strategyList" :key="index" :label="strategy['name']" :value="strategy.id"></el-option>
                </el-select>
            </el-form-item>
            <!-- <el-form-item label="任务名称">
                <input class="task-name-add" v-model="addTaskData.taskName" placeholder="请填写任务名称"/>
                <span class="task-error-msg" v-if="typeof this.addTaskData.taskName == 'undefined'">请填写任务名称</span>
            </el-form-item>
            <el-form-item v-for="(item, index) in taskBaseParamJudge(strategyParam.taskBaseParams)" :key="index" :label="paramJugde(index)">
                <el-select v-if="index == 'a_bourse'" v-model="addTaskData.a_bourse" @change="bourseChange('a')" :placeholder="item">
                    <el-option v-for="(bourse, index) in bourseList.bourse" :key="index" :label="bourse" :value="index"></el-option>
                </el-select>
                <el-select v-else-if="index == 'a_transaction_type'" v-model="addTaskData.a_transaction_type" @change="aTransTypeChange(index)" :placeholder="item">
                    <el-option v-for="(type, index) in abourseType" :key="index" :label="addBourseStr(type)" :value="addBourseValue(type, index)"></el-option>
                </el-select>
                <el-select v-else-if="index == 'b_bourse'" v-model="addTaskData.b_bourse" @change="bourseChange('b')" :placeholder="item">
                    <el-option v-for="(bourse, index) in bourseList.bourse" :key="index" :label="bourse" :value="index"></el-option>
                </el-select>
                <el-select v-else-if="index == 'b_transaction_type'" v-model="addTaskData.b_transaction_type" @change="aTransTypeChange(index)" :placeholder="item">
                    <el-option v-for="(type, index) in bbourseType" :key="index" :label="addBourseStr(type)" :value="addBourseValue(type, index)"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item :label="'币种'" v-if="strategyParam.taskBaseParams">
                <el-select  v-model="addTaskData.currency_type" :placeholder="strategyParam.taskBaseParams['currency_type']"> 
                    <el-option v-for="(currencyItem, index) in currencyList" :key="index" :label="currencyItem" :value="index"></el-option>
                </el-select>
            </el-form-item> -->
            <!-- <span class="task-error-msg" v-show="ErrorVisible">参数没填写完全!</span> -->



            <el-divider v-if="JSON.stringify(strategyParam.debitCreditParams) !== '{}'"><strong>交易和借贷参数</strong></el-divider>
            <el-form-item v-for="(selfParam, index) in strategyParam.debitCreditParams" :key="index" :label="debitCreditName(index)">
                <el-switch v-if="index == 'is_borrow'" v-model="addTaskData[index]"></el-switch>
                <div v-else-if="index == 'fund_occupy'">
                    <select class="assets-select" v-model="radio">
                        <option :value="1">百分比</option>
                        <option :value="0">金额</option>
                    </select>
                    <el-input v-model="addTaskData[index]" :placeholder="selfParam"></el-input>
                </div>
                <el-input v-else v-model="addTaskData[index]" :placeholder="selfParam"></el-input>
            </el-form-item>

            <el-divider v-if="JSON.stringify(strategyParam.strategyParams) !== '{}'"><strong class="divider-btn" @click="paramSwitch()"><a>策略参数 <i class="fa fa-refresh" aria-hidden="true"></i></a></strong></el-divider>
            <div class="form-change-btn">
                
            </div>
            <div v-if="showFlag">
                <el-form-item v-for="(selfParam, index) in handleStrategyParam.other" :key="index" :label="index">
                    <el-input v-model="addTaskData[index]" :placeholder="selfParam"></el-input>
                </el-form-item>
                <div class="strategy-param">
                    <div>
                        <span>本周</span>
                        <el-form-item v-for="(selfParam, index) in handleStrategyParam.mDlt" :key="index" :label="index">
                            <el-input v-model="addTaskData[index]['CW']" :placeholder="selfParam"></el-input>
                        </el-form-item>
                    </div>
                    <div>
                        <span>次周</span>
                        <el-form-item v-for="(selfParam, index) in handleStrategyParam.mDlt" :key="index" :label="index">
                            <el-input v-model="addTaskData[index]['NW']" :placeholder="selfParam"></el-input>
                        </el-form-item>
                    </div>
                    <div>
                        <span>季度</span>
                        <el-form-item v-for="(selfParam, index) in handleStrategyParam.mDlt" :key="index" :label="index">
                            <el-input v-model="addTaskData[index]['CQ']" :placeholder="selfParam"></el-input>
                        </el-form-item>
                    </div>
                    <div>
                        <span>次季</span>
                        <el-form-item v-for="(selfParam, index) in handleStrategyParam.mDlt" :key="index" :label="index">
                            <el-input v-model="addTaskData[index]['NQ']" :placeholder="selfParam"></el-input>
                        </el-form-item>
                    </div>
                </div>
            </div>

            <div v-else>
                <el-form-item v-for="(selfParam, index) in strategyParam.strategyParams" :key="index" :label="index">
                    <el-input v-model="addTaskData[index]" :placeholder="selfParam"></el-input>
                </el-form-item>
            </div>
        </el-form>
        <el-divider></el-divider>
        <div class="add-task-footer">
            <div class="info-show">
                <p v-for="(info, index) in notifyInfo" :key="'info-'+index">{{info}}</p>
            </div>
            <div class="footer-btn">
                <el-button @click="submitParam">确认</el-button>
                <el-button @click="dialogVisible.visible = false">取消</el-button>
            </div>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
import { mapState, mapActions } from 'vuex'
import { post, get, put } from '@/api/index'
import { deepClone } from '@/utils/common'

export default {
    data() {
        return{
            addTaskVisible: true,
            menuKey: 1,
            addTaskData: {},
            ErrorVisible: false,
            radio: '1',
            okexBourseTransaction1: {'本周': 2, "次周": 3, '季度': 4},
            huobiBourseTransaction1: {'本周': 7, "次周": 8, '季度': 9},
            transactionTypeList: [2, 3, 4, 7, 8, 9],
            newStrategyParam: {'dlt': {}, 'm': {}},

            showFlag: false,
            strategyParam: {},
            strategySelectData: '',
            notifyInfo: [],
        }
    },
    watch: {

    },
    created() {
        
        // 获取策略列表及参数
        this.getStrategyList().then(data => {
            if (data.length !== 0) {// data 不为空
                // 默认选中第一个
                this.addTask.strategySelect = data[0].id;
                this.strategySelectData = data[0].id;
                
                // 获取策略默认参数
                this.getStrategyParam().then(data => {
                    this.strategyParam = data;
                });
            }
        });
    },
    mounted() {
        
    },
    computed: {
        ...mapState([
            'bourseList',
            'addTask',
            'strategyList',
            'currencyList',
            'abourseType',
            'bbourseType',
            'token',
            'dialogVisible',
            'currencyNum',
            'tradeTypeObj',
            'currencyNumList',
            'taskBoxSelect'
        ]),

        // 策略参数处理
        handleStrategyParam: function () {
            if (this.strategyParam.strategyParams) {
                var new_param = deepClone(this.strategyParam.strategyParams)

                delete new_param['dlt'];
                delete new_param['m'];

                var param = {
                    'mDlt': {'dlt': this.strategyParam.strategyParams['dlt'], 'm': this.strategyParam.strategyParams['m']},
                    'other':  new_param
                };
                return param
            }
        },

    },
    methods: {
        ...mapActions([
            'getBourseList',
            'getaBourseType',
            'getbBourseType',
            'getStrategyList',
            'getStrategyParam',
            'getTaskList',
            'getCurrencyNum'
        ]),

        // 策略选择事件
        strategyChange() {
            this.addTask.strategySelect = this.strategySelectData;
            this.getStrategyParam().then(data => {
                this.strategyParam = data;
            })
        },

        // 策略参数切换
        paramSwitch() {
            this.showFlag = !this.showFlag;
            if (this.showFlag) {// 字典
                this.$set(this.addTaskData, 'dlt', {})
                this.$set(this.addTaskData, 'm', {})
            } else {
                this.$set(this.addTaskData, 'dlt', '')
                this.$set(this.addTaskData, 'm', '')
            }
        },

        // 借贷参数名判断
        debitCreditName(name) {
            if (name == 'fund_occupy') return '资金可占用比';
            else if (name == 'is_borrow') return '是否允许可借贷';
            else if (name == 'virtual_initial_capital') return '任务虚拟初始资金';
            else if (name == 'depth') return '价格深度';
            else if (name == 'slip') return '滑点';
            else if (name == 'price_limit') return '价格控制';
            return name;
        },


        // 参数批量转换
        taskParamTranform(data) {
            var taskParam = this.handleTaskParam(data);

            for (var i in this.addTaskData) {
                var data_i = this.addTaskData[i];
                // 如果值存在，将值放入所有任务的配置中
                if (i == 'dlt' || i == 'm') {
                    if (this.showFlag && JSON.stringify(data_i) !== '{}') {// true dlt,m 为字典
                        if (this.addTaskData.hasOwnProperty('dlt')) {
                            taskParam['dlt'] = JSON.stringify(this.addTaskData['dlt']);
                        } 
                        if (this.addTaskData.hasOwnProperty('m')) {
                            taskParam['m'] = JSON.stringify(this.addTaskData['m']);
                        }
                    } else if (!this.showFlag && data_i) {// dlt,m 为字符串
                        if (this.addTaskData.hasOwnProperty('dlt')) {
                            taskParam['dlt'] = this.addTaskData['dlt']
                        } 
                        if (this.addTaskData.hasOwnProperty('m')) {
                            taskParam['m'] = this.addTaskData['m'];
                        }
                    }
                } else {
                    taskParam[i] = data_i;
                }
            }
            return taskParam;
        },

        // 获取选中任务的配置参数
        getSelectTaskParam(taskId) {
            var url = this.$baseUrl + '/task/params/get';
            var param = {
                'token': this.token,
                'taskId': taskId
            }
            get(url, param).then(resp => {
                if (resp.code == 200) {
                    var submit_data = this.taskParamTranform(resp.data)
                    this.saveTaskParam(submit_data, taskId);
                }
            })
        },

        // 任务配置参数处理
        handleTaskParam(data) {
            if (data) {
                var paramObj = {};
                for (var i in data) {
                    for (var j in data[i]) {
                        paramObj[j] = data[i][j];
                    }
                }
                return paramObj;
            }
        },

        // 提交任务参数接口
        saveTaskParam(param, taskId) {
            var url = this.$baseUrl +  '/task/params/update';
            var paramObj = {
                'token': this.token,
                'taskId': taskId,
                'params': param
            }
            put(url, JSON.stringify(paramObj)).then(resp => {
                if (resp.code == 200) {
                    var info = '任务-'+taskId+'：操作成功!';
                    this.notifyInfo.push(info)
                } else {
                    var info = '任务-'+taskId+'：操作失败!';
                    this.notifyInfo.push(info)
                    this.$notify.error({
                        message: '任务-'+taskId+'：操作失败!',
                        title: '提示',
                        offset: 100
                    })
                }
                if (this.taskBoxSelect.length == this.notifyInfo.length) {
                    setTimeout(() => {
                        this.dialogVisible.visible = false;
                    }, 4000)
                }
            })
        },

        // 参数提交
        submitParam() {
            // console.log(this.addTaskData);
            this.notifyInfo = [];
            if (this.taskBoxSelect.length !== 0) {
                for (let i in this.taskBoxSelect) {// 遍历 已选任务id列表
                    this.getSelectTaskParam(this.taskBoxSelect[i]);
                }
            } else {
                this.$notify.error({
                    message: '请选择任务!',
                    title: '提示',
                    offset: 100,
                    duration: 1000
                })
            }
        },
    }
}
</script>

<style lang="scss">
    .add-task-dialog{
        .add-task-title{
            // background-color: #000;
            padding: 15px 15px 5px 15px;
            h3{
                text-align: center !important;
                font-size: 23px;
            }
        }
        .el-divider{
            margin: 10px 0;
        }
        .divider-btn{
            cursor: pointer;
        }
        .el-form{
            width: 75%;
            margin: 0 auto;
            padding: 10px 20px;
            .task-error-msg{
                color: #ea1a1a;
            }
            .strategy-param{
                display: flex;
                justify-content: flex-start;
                div{
                    .el-form-item{
                        .el-form-item__label{
                            width: 50px !important;
                        }
                        .el-form-item__content{
                            margin-left: 50px !important;
                        }
                    }
                }
            }
            .form-change-btn{
                text-align: left;
            }
            .el-form-item{
                .task-name-add{
                    border: 1px solid #DCDFE6;
                    padding: 0 15px;
                    width: 100%;
                    border-radius: 4px;
                    -webkit-appearance: none;
                    display: inline-block;
                    outline: none;
                    box-sizing: border-box;
                    color: #606266;
                    height: 32px;
                    line-height: 32px;
                }
                .el-select{
                    display: flex;
                }
                .el-form-item__content{
                    text-align: left;
                    .el-input__inner{
                        // width: 60%;
                        // min-width: 225px;
                        font-size: 13px;
                    }
                    .assets-select{
                        padding: 4px 5px;
                        border-color: #DCDFE6;
                        font-size: 12px;
                        border-radius: 3px;
                    }
                }
            }
        }
        .add-task-footer{
            padding: 0 10px 15px 10px;
            // text-align: right;
            display: flex;
            justify-content: space-between;
            .info-show{
                height: 50px;
                font-size: 12px;
                overflow-y: auto;
                width: 30%;
                padding: 0 5px;
                p{
                    text-align: left;
                    font-size: 12px;
                }
            }
            .el-button{
                padding: 10px 20px !important;
                background-color: #fff;
            }
        }
    }

    // @media screen
</style>


